<template>
  <div v-if="animation" class="word">
     <span :class="['word--letter', {'word--letter-animate': animation && isAnimated}]" :style="`animation-duration: ${delay + (key * speed)}ms `" v-for="letter, key in word">{{ letter }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    word: { type: String, required: true },
    delay: { type: Number, required: false, default: 0 },
    speed: { type: Number, required: false, default: 100 },
  },

  computed: mapGetters({
    animation: 'animation',
  }),

  data() {
    return {
      isAnimated: false,
    };
  },

  mounted() {
    setTimeout(() => {
      this.isAnimated = true;
    }, 100);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@keyframes title{
  from {
    transform: translate3d(0,170px,0);
  }
  to {
    transform: translate3d(0,0,0);
  }
}

.word{
  white-space: nowrap;
  overflow: hidden;
  min-width: 600px;

  &--letter{
    transform: translate3d(0,200px,0);
    transform-origin: bottom center;
    position: relative;
    min-width: 5px;
    opacity: 0;

    &-animate{
      animation: title 400ms $mainAnimationTransition;
      transform: translate3d(0,0,0);
      display: inline-block;
      opacity: 1;
    }

  }  
}
</style>



// WEBPACK FOOTER //
// src/components/TextAnimation.vue